import { all, put, takeEvery } from "@redux-saga/core/effects";
import { createNewfile } from "../../Services/database";
import { setErrorStatus, setSuccessStatus } from "../status/action";
import store from "../store";
import { dateAndTimeConverter } from "../../Utils/Constants/Constants";

export const actionTypes = {
  SET_REPORTS_DATA: "SET_REPORTS_DATA",
  UPLOAD_REPORT: "UPLOAD_REPORT",
  DOWNLOAD_REPORT: "DOWNLOAD_REPORT"
};

function* setReportsDataWorker(action) {
  setReportsLoading(true);
  yield put({
    type: "PUT_REPORTS_DATA",
    payload: { data: action.payload.data }
  });
  yield setReportsLoading(false);
}

function* uploadReportWorker(action) {
  try {
    yield setUploadReportLoading(true);

    const { from, to, type, name, file } = action.payload;

    const state = store.getState();
    const auth = state.auth.data;
    const profile = state.profile.data;

    const uploaderInfo = {
      email: auth.email,
      ...(profile.name && { name: profile.name }),
      ...(profile.employeeId && { id: profile.employeeId })
    };

    const fileExt = file?.name?.split(".").pop();
    const updatedFileName = name
      ? `${name.trim().replaceAll(" ", "_")}_${dateAndTimeConverter(
          from,
          "secondDate"
        ).replaceAll(" ", "_")}-${dateAndTimeConverter(
          to,
          "secondDate"
        ).replaceAll(" ", "_")}.${fileExt}`
      : `${type.replaceAll(" ", "_")}_${dateAndTimeConverter(
          from,
          "secondDate"
        ).replaceAll(" ", "_")}-${dateAndTimeConverter(
          to,
          "secondDate"
        ).replaceAll(" ", "_")}.${fileExt}`;

    const data = {
      uploadedBy: uploaderInfo,
      uploadedFor: uploaderInfo,
      type: type,
      name: updatedFileName,
      info: {
        period: {
          from: +new Date(from),
          to: +new Date(to)
        }
      },
      createdAt: Date.now()
    };

    yield createNewfile(data, file, updatedFileName);
    yield setSuccessStatus("Report uploaded successfully");
    yield setUploadReportLoading(false);
  } catch (error) {
    setErrorStatus(error, "from create Report");
  } finally {
    yield setUploadReportLoading(false);
  }
}

function* setReportExportLoadingWorker(action) {
  yield put({
    type: "SET_REPORTS_EXPORT_LOADING",
    payload: {
      loading: action.payload.loading
    }
  });
}

export default function* reportsWatcher() {
  yield all([
    takeEvery("SET_REPORTS_DATA", setReportsDataWorker),
    takeEvery("PUT_REPORTS_EXPORT_LOADING", setReportExportLoadingWorker),
    takeEvery("UPLOAD_REPORT", uploadReportWorker)
  ]);
}

function* setReportsLoading(bool) {
  yield put({
    type: "SET_REPORTS_LOADING",
    payload: {
      loading: bool
    }
  });
}

function* setUploadReportLoading(bool) {
  yield put({
    type: "SET_UPLOAD_REPORT_LOADING",
    payload: {
      loading: bool
    }
  });
}
